import { render, staticRenderFns } from "./partySecondPage.vue?vue&type=template&id=c845298a&scoped=true&"
import script from "./partySecondPage.vue?vue&type=script&lang=js&"
export * from "./partySecondPage.vue?vue&type=script&lang=js&"
import style0 from "./partySecondPage.vue?vue&type=style&index=0&id=c845298a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c845298a",
  null
  
)

export default component.exports